import { ICreator } from '@leafer/interface'


export const Creator: ICreator = {

}